// extracted by mini-css-extract-plugin
export default {"RatingsCard":"RatingsCard_RatingsCard__MTYzZ","RatingsCard__divided":"RatingsCard_RatingsCard__divided__ZTdiZ"};